import { create_api } from './base';

export default class NoteRepo {
  // no-dd-sa:javascript-best-practices/no-unreachable
  baseUrl = '/notes';

  constructor() {
    this.api = create_api(import.meta.env.REACT_APP_API_ROOT);
  }

  get = (id) =>
    this.api.get(`${this.baseUrl}/${id}`).then((r) => ({
      ok: r.status === 200,
      status: r.status,
      data: r.status === 200 ? r.data : [],
    }));
  add = (id, content) => this.api.post(`${this.baseUrl}/${id}`, content).then((r) => r.data);
}
